import React from 'react';
import cn from 'classnames';
import { FormikErrors, FormikTouched, FormikValues, useField } from 'formik';
import dynamic from 'next/dynamic';
import { DataField } from '../data/dataType';
import { LabelField } from '../data/LabelField';

const TiptapEditor = dynamic(() => import('../ui/tiptap/TiptapEditor'), {
    ssr: false,
});

const EditorField: React.FC<{
    dataField: DataField;
    dirty: boolean;
    errors: FormikErrors<FormikValues>;
    locale: string;
    touched: FormikTouched<FormikValues>;
}> = props => {
    const { dataField, dirty, errors, locale, touched } = props;
    const [field, , helpers] = useField(dataField.name);

    const setChange = (value: string) => {
        helpers.setValue(value);
    };

    return (
        <div className="w-full my-3">
            <div className="w-full flex my-2">
                <div className="flex-none mt-1">
                    <LabelField
                        dirty={dirty}
                        errors={errors}
                        field={dataField}
                        locale={locale}
                        touched={touched}
                    />
                </div>
            </div>
            <div className="card w-full p-0 ">
                <div
                    className={cn(
                        'w-full bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary dark:focus:border-primary ',
                        errors[field.name] &&
                            touched[field.name] &&
                            'bg-red-50',
                    )}
                >
                    <TiptapEditor
                        handleEditorChange={value => setChange(value)}
                        initialValue={field.value}
                        locale={locale}
                    />
                </div>
            </div>
        </div>
    );
};

export default EditorField;
